/* @flow */

export default class Kpi {
  name: string;
  value: number;
  threshold: number;
}
